exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-tree {\n  overflow: auto;\n  border-right: 1px solid #6d757d;\n}\n.fm-tree > .fm-folders-tree {\n  padding-left: 0.2rem;\n}\n.fm-tree .fm-tree-disk {\n  padding: 0.2rem 0.3rem;\n  margin-bottom: 0.3rem;\n  background-color: white;\n}\n.fm-tree .fm-tree-disk > i {\n  padding-left: 0.2rem;\n  padding-right: 0.5rem;\n}", ""]);

// exports
